import { FC, ReactElement, useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { UserPermissions } from 'api/users/types';
import FullScreenLoader from 'components/Loaders/FullScreenLoader';
import { useAuth } from 'context/Auth/AuthContext';
import routes from 'routes';

type PermissionRouteProps = {
  permission: keyof UserPermissions;
  children: ReactElement;
};

const PermissionRoute: FC<PermissionRouteProps> = ({ permission, children }) => {
  const { user, isUserLoading } = useAuth();

  const permissionsSchema = useMemo<Partial<UserPermissions> | null>(() => {
    return user?.permissionsSchema || user?.permissions || user?.appUser?.permissions || null;
  }, [user]);

  if (isUserLoading) {
    return <FullScreenLoader />;
  }

  if (!permissionsSchema) {
    return <Navigate to={routes.notAuthorized} replace />;
  }

  if (!permissionsSchema[permission]) {
    return <Navigate to={routes.notAuthorized} replace />;
  }

  return children;
};

export default PermissionRoute;
